module.exports = __webpack_public_path__ + "img/operation-delect.c1ec1a14.png";